<template>
  <div class="sideBarBox">
    <div class="sideBar">
      <div v-for="(item, idx) in QRCodes" :key="idx">
        <el-tooltip
          :content="'<img src=' + item.imgSrc + ' />'"
          raw-content
          placement="left"
          effect="light"
        >
          <div class="itemBox cursor-pointer">
            <img :src="item.logo" alt="" />
            <div>{{ item.desc }}</div>
          </div>
        </el-tooltip>
      </div>
      <div class="freeTest cursor-pointer" @click="freeTest">
        免费<br />测试
      </div>
    </div>
    <!-- <div class="customer cursor-pointer">
            <img :src="customer" alt="" />
            <div>客服</div>
        </div> -->
  </div>
</template>
<script>
import Wechat from "@/assets/imgs/footer/wechat.png";
import whatsapp from "@/assets/imgs/footer/whatsapp.png";
import telegram from "@/assets/imgs/footer/telegram.png";
import telegramLogo from "@/assets/imgs/sidebar/telegram.png";
import whatsappLogo from "@/assets/imgs/sidebar/whatsapp.png";
import wechatLogo from "@/assets/imgs/sidebar/wx.png";
// import customer from "@/assets/imgs/sidebar/Frame.svg";
export default {
  data() {
    return {
      Wechat,
      whatsapp,
      telegram,
      telegramLogo,
      whatsappLogo,
      wechatLogo,
      QRCodes: [
        {
          desc: "微信",
          imgSrc: Wechat,
          logo: wechatLogo,
        },
        {
          desc: "Whatsapp",
          imgSrc: whatsapp,
          logo: whatsappLogo,
        },
        {
          desc: "Telegram",
          imgSrc: telegram,
          logo: telegramLogo,
        },
      ],
    };
  },
  methods: {
    freeTest() {
      this.$emit("on-free-test");
    },
  },
};
</script>
<style scoped>
.sideBarBox {
  top: calc(50% - 150px);
  right: 10px;
  position: fixed;
}
.sideBar {
  width: 54px;
  height: 272px;
  flex-shrink: 0;
  border-radius: 26px;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 4px 4px 0px rgba(156, 156, 156, 0.25);
  backdrop-filter: blur(10px);
  padding: 12px 12px 4px;
}
.sideBar > div:not(:first-child) {
  margin-top: 16px;
}
.itemBox div {
  color: #343434;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  margin-top: 5px;
  word-wrap: break-word;
  text-align: center;
}
.freeTest {
  margin-top: 18px !important;
  border-radius: 46px;
  width: 46px;
  height: 46px;
  color: #fff;
  background: linear-gradient(180deg, #5192fd 0%, #1d6ced 100%);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  margin-left: -8px;
  text-align: center;
  padding-top: 8px;
}
.customer {
  width: 54px;
  height: 54px;
  margin-top: 30px;
  text-align: center;
  border-radius: 43px;
  background: linear-gradient(180deg, #5192fd 0%, #1d6ced 100%);
  box-shadow: 0px 4px 6.7px 0px rgba(157, 157, 157, 0.25);
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 12px;
  padding: 9px;
}
.customer img {
  display: inline;
}
.customer div {
  margin-top: 2px;
}
@media (max-width: 768px) {
}
</style>